import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faTrash,
  faClock,
  faCalendarWeek,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";

const ScheduleEditor = ({ schedule = {}, onChange, disabled = false }) => {
  const daysOfWeek = [
    { key: "monday", label: "Luni" },
    { key: "tuesday", label: "Marți" },
    { key: "wednesday", label: "Miercuri" },
    { key: "thursday", label: "Joi" },
    { key: "friday", label: "Vineri" },
    { key: "saturday", label: "Sâmbătă" },
    { key: "sunday", label: "Duminică" },
  ];

  // Initialize schedule with empty arrays for each day if not provided
  const [currentSchedule, setCurrentSchedule] = useState(() => {
    const initialSchedule = {};
    daysOfWeek.forEach((day) => {
      initialSchedule[day.key] = schedule[day.key] || [];
    });
    return initialSchedule;
  });

  useEffect(() => {
    if (onChange) {
      onChange(currentSchedule);
    }
  }, [currentSchedule, onChange]);

  const addTimeSlot = (dayKey) => {
    setCurrentSchedule((prev) => ({
      ...prev,
      [dayKey]: [...prev[dayKey], { start: "09:00", end: "17:00" }],
    }));
  };

  const removeTimeSlot = (dayKey, index) => {
    setCurrentSchedule((prev) => ({
      ...prev,
      [dayKey]: prev[dayKey].filter((_, i) => i !== index),
    }));
  };

  const updateTimeSlot = (dayKey, index, field, value) => {
    setCurrentSchedule((prev) => ({
      ...prev,
      [dayKey]: prev[dayKey].map((slot, i) =>
        i === index ? { ...slot, [field]: value } : slot
      ),
    }));
  };

  const validateTimeSlot = (start, end) => {
    return start < end;
  };

  const formatScheduleDisplay = (daySchedule) => {
    if (!daySchedule || daySchedule.length === 0) {
      return "Liber";
    }
    return daySchedule
      .map((slot) => `${slot.start} - ${slot.end}`)
      .join(", ");
  };

  return (
    <div className="schedule-editor">
      <div className="schedule-header mb-3">
        <h5>
          <FontAwesomeIcon icon={faCalendarWeek} className="me-2" />
          Program Săptămânal
        </h5>
        <small className="text-muted">
          <FontAwesomeIcon icon={faInfoCircle} className="me-1" />
          Adaugă intervalele orare pentru fiecare zi din săptămână
        </small>
      </div>

      <div className="schedule-days">
        {daysOfWeek.map((day) => (
          <div key={day.key} className="schedule-day mb-3">
            <div className="day-header d-flex justify-content-between align-items-center mb-2">
              <h6 className="mb-0">
                <span className="day-label">{day.label}</span>
                <small className="text-muted ms-2">
                  ({formatScheduleDisplay(currentSchedule[day.key])})
                </small>
              </h6>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={() => addTimeSlot(day.key)}
                disabled={disabled}
              >
                <FontAwesomeIcon icon={faPlus} className="me-1" />
                Adaugă Interval
              </button>
            </div>

            <div className="time-slots">
              {currentSchedule[day.key].length === 0 ? (
                <div className="no-schedule text-muted">
                  <FontAwesomeIcon icon={faClock} className="me-2" />
                  Niciun interval programat
                </div>
              ) : (
                currentSchedule[day.key].map((slot, index) => (
                  <div key={index} className="time-slot mb-2">
                    <div className="row g-2 align-items-center">
                      <div className="col-md-4">
                        <label className="form-label small">Ora început:</label>
                        <input
                          type="time"
                          className="form-control form-control-sm"
                          value={slot.start}
                          onChange={(e) =>
                            updateTimeSlot(day.key, index, "start", e.target.value)
                          }
                          disabled={disabled}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label small">Ora sfârșit:</label>
                        <input
                          type="time"
                          className="form-control form-control-sm"
                          value={slot.end}
                          onChange={(e) =>
                            updateTimeSlot(day.key, index, "end", e.target.value)
                          }
                          disabled={disabled}
                        />
                      </div>
                      <div className="col-md-4 d-flex align-items-end">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeTimeSlot(day.key, index)}
                          disabled={disabled}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                        {!validateTimeSlot(slot.start, slot.end) && (
                          <div className="invalid-feedback d-block ms-2">
                            Ora sfârșit trebuie să fie după ora început
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="schedule-summary mt-4 p-3 bg-light rounded">
        <h6>Rezumat Program:</h6>
        <div className="row">
          {daysOfWeek.map((day) => (
            <div key={day.key} className="col-md-6 col-lg-4 mb-2">
              <strong>{day.label}:</strong>{" "}
              <span className="text-muted">
                {formatScheduleDisplay(currentSchedule[day.key])}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ScheduleEditor; 